import React, { useState,useContext, useEffect } from 'react'
import './dmdash.css'
import Sidebar from '../../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressCard, faAngleRight, faBook, faCircleCheck, faCircleInfo, faClose, faEnvelopeCircleCheck, faFileCirclePlus, faFileLines, faPlus, faSignature, faStamp, faUserLock, faUserPen } from '@fortawesome/free-solid-svg-icons'
import { faFolderOpen } from '@fortawesome/free-regular-svg-icons'
import { Link, useNavigate } from 'react-router-dom'
import BackLoader from '../../../components/backloader'
import * as Constants from '../../../constants';
import { ShareContext } from '../../../context/ShareContext'
import TopBar from '../../../components/topbar'
import JisAlert from '../../../components/jisalert'
import moment from 'moment'

function DMDashboard() {
    const [whichAcc, setWhichAcc] = useState('legal-counsel')
    const { profile } = useContext(ShareContext)
    const navigate = useNavigate();
    
  //  const profileid=Constants.isServerEnv? Constants.getCookie("profilename"):'seniola1' ;  
    const url=`${Constants.apiUrl}/gazette/eswearing/${profile.username}`;

    const urlcfo=`${Constants.apiUrl}/gazette/cfodocuments/pending`;

    const tempUrl= `${Constants.apiUrl}/gazette/templates/affidavit`;

    const urlSaveInst = `${Constants.apiUrl}/gazette/uploadinstrument/${profile.username}`;
    const urlInstrument=`${Constants.apiUrl}/gazette/instrument/${profile.username}`;

    const [docs, setDocs] = useState([]);
    const [cases, setCases]=useState([]);
    const [refs, setRefs]=useState([]);
    const [isLoading,setIsLoading]= useState(false);
    const [templates, setTemplates]=useState([]);
    const [isSchedule, setIsSchedule] =useState(false);
    const [schedule, setSchedule]= useState({});
    const [alert, setAlert] = useState({open:false})
    //for quick upload //load instrument too

    const [seal, setSeal]=useState('');
    const [passport, setPassport] =useState('');
    const [sign, setSign] =useState('');
    const [stamp, setStamp] =useState('');
    const [initial, setInitial] =useState('');
    const [imgPrev, setImgPrev]=useState ({data:'', type:'', open:false});

    const [config, setConfig]=useState({});
    const [isPay, setIsPay] =useState(false);
    const [selectedtempid, setSelectedTempId]=useState(0);
    const [isCfo, setIsCfo] = useState(false);

    const onCancel=()=>{
        setIsPay(false);
        setSelectedTempId(0);
      }
   
    const onSelectSchedule=(item)=>{
        console.log(item);
        setIsSchedule(true);
        setSchedule({...schedule, doc:item});

        
    }
    const onSaveSchedule=()=>{
        console.log(schedule);
        var sch={docid:schedule.doc.id, zoomLink:schedule.zoom, scheduledBy:profile.username, scheduleDate : (schedule.date+' '+schedule.time)};

        setIsSchedule(false);
        const uploadurl=`${Constants.apiUrl}/gazette/schedule/${schedule.doc.id}`
        const formData = new FormData();
          

            // Sending the FormData using fetch
            setIsLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(sch),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false);
                if(data.code==0){
                    //saved already
                    //first upldate the row and show dialog box
                    setDocs(docs.map(i => i.id === schedule.doc.id ? {...i, zoomLink:sch.zoomLink, schedule:sch.scheduleDate} : i));

                   setSchedule({});
                   setAlert({open:true, title:'Schedule Appointment', subtitle:'Meeting Schedule is successful', onOk})
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setIsLoading(false);
        });
    }

    const onLoadInstrument= async()=>{
        //for account registration
        console.log(`the calling url ${urlInstrument}`);
        try {
            setIsLoading(true);
            const resp = await fetch(urlInstrument, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            if(data.code==0){
                //check if it contain any of the items
                console.log('the loaded instrument');
                console.log(data);
                for( const x of data.inst ){
                    onSetImg(x.instPath, x.instrument)
                }
                
            }
            
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
const onSetImg =(path,type)=>{
        const ct=type.toLowerCase()
        if(ct=='seal'){
            setSeal(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='passport'){
            setPassport(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='signature'){
            setSign(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='initial'){
            setInitial(  `${Constants.docUrl}instrument/${path}`);
        }else if(ct=='stamp'){
            setStamp(  `${Constants.docUrl}instrument/${path}`);
        }
      
    }
 
    const dummyCaseDocs = [
        {
            title: 'CLAIMANTS’LIST OF WITNESS(ES)'
        },
        {
            title: 'AMENDED STATEMENT OF CLAIM'
        },
        {
            title: 'COUNTER AFFIDAVIT'
        },
        {
            title: 'ISSUES FOR DETERMINATION'
        },
        {
            title: 'FORM 18'
        },
        {
            title: 'DEFENDANTS’ AMENDED STATEMENT OF DEFENC'
        },
        {
            title: 'ANSWER'
        },
        {
            title: 'COUNTER AFFIDAVIT AGAINST'
        },
        {
            title: "DEFENDANT'S JOINT REPLY"
        },
        {
            title: 'MEMORANDUM OF ISSUES FOR DETERMINATION'
        },
        {
            title: 'FURTHER AND BETTER AFFIDAVIT'
        },
        {
            title: 'AFFIDAVIT OF URGENCY'
        },
        {
            title: 'AFFIDAVIT OF NON-SETTLEMENT'
        },
        {
            title: 'DEFENDANTS AMENDED STATEMENT OF DEFENCE'
        },
        {
            title: 'AFFIDAVIT OF NON-RESPONSE AND INTENTION TO PROCEED TO CIVIL LITIGATION'
        },
        {
            title: 'CERTIFICATE OF COMPLIANCE WITH SECTION 84 OF THE EVIDENCE ACT'
        },
        {
            title: 'NOTICE OF PRELIMINARY OBJECTION'
        },
        {
            title: 'AMENDED STATEMENT OF CLAIM'
        },
        {
            title: 'MEMORANDUM OF ISSUES FOR DETERMINATION'
        },
        {
            title: 'AFFIDAVIT OF URGENCY'
        },
    ]
    const onConfig= async()=>{
        
        const urls=`${Constants.apiUrl}/gazette/getsettings`;
        console.log(`the calling url ${urls}`);

        try {
           
            const resp = await fetch(urls, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            const data = await resp.json();
           setConfig(data);
            
          } catch (error) {
            console.error(error);
          }   
  }
  const onSelectTemplate=(selected)=>{
    // navigate('/upload/create-case')
    // navigate(`/AffidavitDocuments/${selected.id}/create`)
    setSelectedTempId(selected.id);
     onCloseTemp();
     setIsPay(true);
   }
   const onCloseTemp=()=>{
    setOpenLegalDoc(false);
    
  }

    // LEGAL COUNSEL STATES
    const [openLegalDoc, setOpenLegalDoc] = useState(false)
    const [typeTemp, setTypeTemp] = useState('')
    const [isUploadClick, setIsUploadClick] = useState(false)
    const [uploadType, setUploadType] = useState('')
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedFile, setActiveFile] = useState();

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setActiveFile(file);
        if (file) {
          const reader = new FileReader();
    
          reader.onload = () => {
            setSelectedImage(reader.result);
          };
    
          reader.readAsDataURL(file);
        }
      }

    const openTemp = (type) => {
        setOpenLegalDoc(true)

        if (type === 'affidavit') {
            setTypeTemp('affidavit')
        } else if (type === 'case-doc') {
            setTypeTemp('case-doc')
        }
    }

    const openUpload = (item) => {
        setIsUploadClick(true)

        if (item === 'sign') {
            setUploadType('Signature')
        } else if (item === 'seal') {
            setUploadType('Seal')
        } else if (item === 'stamp') {
            setUploadType('Stamp')
        } else if (item === 'passport') {
            setUploadType('Passport')
        } else if (item === 'initial') {
            setUploadType('Initial')
        }
    }

    const cancelUpload = () => {
        setIsUploadClick(false)

        setSelectedImage(null)
    }

   

      useEffect(() => {
       if((profile.role=='CommissionerForOaths' || profile.role=='e-CFO' || profile.role=='e-Commissioner for Oaths'  || profile.role=='ACR' || profile.role=='e-ACR')  ){
        onLoadCfoData();
        setIsCfo(true);
       }
       onConfig();
       onLoad();
        LoadTemplates();
        onLoadInstrument();
      }, [profile]);


      const onLoad= async()=>{
        //for account registration
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            if(data.code==0){

            }
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                setDocs(data.docs);
                setCases(data.cases);
                setRefs(data.refs)
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const onLoadCfoData= async()=>{
        //for account registration
        console.log(`the calling url ${urlcfo}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            if(data.code==0){

            }
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                setDocs(data.docs);
                setCases(data.cases);
                setRefs(data.refs);
               
            }else {    
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
    const LoadTemplates=()=>{
        // setIsLoading(true);
         fetch(tempUrl, {
             method: 'GET',
             headers: {
               'Content-type': 'application/json',
             },
           })
             .then((resp) => resp.json())
             .then((data) => {
               //  setIsLoading(false);
                 if(data.code==0){
                     setTemplates(data.templates);
                 }
                 
             })
             .catch(error => {
                 console.error(error);
                 //setIsLoading(false);
             })
     }

    const getTitle=(caseid)=>{
        var cc= cases.filter((c) => c.caseId ==caseid);
         if(cc.length==0)
          return 'N/A' 
         else
         return cc[0].caseTitle;
     }
     const getCaseNum=(caseid)=>{
        var cc= cases.filter((c) => c.caseId ==caseid);
         if(cc.length==0)
          return 'N/A' 
         else{
            var cnum=cc[0].caseNumber;
            var inf= cnum.indexOf('Temp');

           return inf==-1? cc[0].caseNumber:getCaseRef(caseid); 
         }
         
     } 
     
     const getCaseRef=(caseid)=>{
        
        var cc= refs?.filter((c) => c.caseId ==caseid);
         if(cc.length==0)
          return 'N/A' 
         else
         return cc[0]?.referenceNumber;
     }

     const onView=(item)=>{
        var a={...item,caseTitle: getTitle(item.caseId),caseNumber:getCaseNum(item.caseId), type:'user'   };
        if(item.doctumentType=='template'){
            navigate("/view-document-template", {state: {item:a}});
        }else{
            navigate("/view-document", {state: {item:a}});
        }
        
 }

    const onSaveInst=()=>{
        onUploadIns();
    }
    const onUploadIns= async()=>{
        console.log('imgPrev data');
        console.log(selectedImage);
     
      
            setIsLoading(true);    
        //setImgPrev({...imgPrev,open:true,data:e.target.result,type:inst, title:"Upload "+inst, });
            var ext=selectedFile.name.split('.')[1];
            var b64=await Constants.toBase64(selectedFile);
            var rdata={base64: b64.split(',')[1],instType:uploadType,ext,changereason:'Initial'};
            // Sending the FormData using fetch
            fetch(urlSaveInst, {
            method: 'POST',
            body: JSON.stringify(rdata),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setIsLoading(false); 
                if(data.code==0){
                    //saved already
                   
                   setAlert( {...alert, title:imgPrev.type, open:true, subtitle:`Saved ${imgPrev.type} successfully`, onOk })
                   setIsUploadClick(false)
                   onSetImg(data.instPath,uploadType);
                   setSelectedImage(null)
                   setActiveFile(null);
                   setUploadType('');
                }
            })
            .catch(error => {
                console.error('Error:', error)
                setIsLoading(false); 
            });
    }

    const onOk=()=>{
        setAlert({open:false});
    }
    // CFO STATES
    const [whichTable, setWhichTable] = useState('submitted')

    const dummyCfoTable = [
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Submitted'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Approved'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Approved'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Submitted'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Approved'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Submitted'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Approved'
        },
        {
            ref: 'LSJ/CD035/2023',
            title: 'FURTHER AFFIDAVIT IN SUPPORT OF THE MOTION FOR MANDATORY INJUNCTION',
            datecreated: 'Thu Mar 23 2023',
            status: 'Submitted'
        }
    ]

    //const approvedDocs = dummyCfoTable.filter(item => item.status === 'Approved');
    const approvedDocs =[];
    const submiitedDocs = dummyCfoTable.filter(item => item.status === 'Submitted');

    const changeTable = (type) => {
        if (type === 'submitted') {
            setWhichTable('submitted')
        } else if (type === 'approved') {
            setWhichTable('approved')
        }
    }

   
  return (
    <div className='dashboard-all'>
        <Sidebar />
        <div className="body">
            <TopBar title="Home"/>
           

            {
                (profile.role === 'LegalCounsel' || profile.role === 'Customer' ) && <div className="create-temp">
                    <h3>Available Templates</h3>
                    <div className="create-btns">
                        <button className='red' onClick={() => openTemp('affidavit')}>View Affidavit Templates</button>
                        
                    </div>
                </div>
            }

            <div className="dashboard-view">
                <h2>Overview</h2>
              { false && <div className="statistics">
                    <div className="stat-box">
                        <div className="box-head">
                            <div className="color-stroke"></div>
                            <h3>General</h3>
                        </div>
                        <div className="stat-body">
                            <div className="stat">
                                <p>Total: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Signatures: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Stamps: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Seals: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Appointments: <span>0</span></p>
                            </div>
                        </div>
                    </div>
                    <div className="stat-box">
                        <div className="box-head">
                            <div className="color-stroke second"></div>
                            <h3>Case Documents</h3>
                        </div>
                        <div className="stat-body">
                            <div className="stat">
                                <p>Total: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Submitted: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Approved: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Drafted: <span>0</span></p>
                            </div>
                        </div>
                    </div>
                    <div className="stat-box">
                        <div className="box-head">
                            <div className="color-stroke third"></div>
                            <h3>Affidavits</h3>
                        </div>
                        <div className="stat-body">
                            <div className="stat">
                                <p>Total: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Submitted: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Approved: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Drafted: <span>0</span></p>
                            </div>
                        </div>
                    </div>
                    <div className="stat-box">
                        <div className="box-head">
                            <div className="color-stroke fourth"></div>
                            <h3>Documents</h3>
                        </div>
                        <div className="stat-body">
                            <div className="stat">
                                <p>Total: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Submitted: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Approved: <span>0</span></p>
                            </div>
                            <div className="stat">
                                <p>Drafted: <span>0</span></p>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>

            {
                (profile.role === 'LegalCounsel' || profile.role === 'Customer' ) && <div className="legal-counsel">
                    <div className="dashboard-view">
                        <h2>Quick Actions</h2>
                        <div className="action-btns" style={{flexWrap:'wrap'}}>
                            <div className="upload-dash" onClick={() => openUpload('sign')}>
                                {sign==''?<div className="icon-text" >
                                    <FontAwesomeIcon icon={faSignature} />
                                    <p>Upload Signature</p>
                                </div>:<img src={ sign} alt="Signature"  style={{width:100, height:100}}/>}
                                {sign!='' && <div className="icon-text" > <p> Signature</p> </div>}
                                <FontAwesomeIcon icon={faCircleInfo} />
                            </div>
                            <div className="upload-dash" onClick={() => openUpload('seal')}>
                              {seal==''?<div className="icon-text">
                                    <FontAwesomeIcon icon={faEnvelopeCircleCheck} />
                                    <p>Upload Seal</p>
                                </div>:<img src={ seal} alt="Seal" style={{width:100, height:100}} />}
                                {seal!='' && <div className="icon-text" > <p>{isCfo && 'CFO'} Seal</p> </div>}
                                <FontAwesomeIcon icon={faCircleInfo} />
                            </div>

                            <div className="upload-dash" onClick={() => openUpload('stamp')}>
                                {stamp==''? <div className="icon-text"> 
                                    <FontAwesomeIcon icon={faStamp} />
                                    <p>Upload Stamp</p>
                                </div>:<img src={stamp} alt="Stamp"  style={{width:100, height:100}}/>}
                                {stamp!='' && <div className="icon-text" > <p>{isCfo && 'CFO'} Stamp</p> </div>}
                                <FontAwesomeIcon icon={faCircleCheck} className='uploaded-it'/>
                            </div>

                            <div className="upload-dash" onClick={() => openUpload('passport')}>
                                {passport==''?<div className="icon-text">
                                
                                    <FontAwesomeIcon icon={faAddressCard} />
                                    <p>Upload Passport</p>
                                </div>:<img src={passport} alt="Passport"  style={{width:100, height:100}} />}
                                {passport!='' && <div className="icon-text" > <p> Passport</p> </div>}
                                <FontAwesomeIcon icon={faCircleCheck} className='uploaded-it' />
                            </div>
                        </div>
                    </div>
                   {profile.role != 'Customer' && <div className="table-apts">
                        <div className="top-table">
                            <div className="all-apts">
                                <FontAwesomeIcon icon={faBook} />
                                <p>All Appointments</p>
                            </div>
                            <Link to=''>View All <FontAwesomeIcon icon={faAngleRight} /></Link>
                        </div>
                        <div className="table-wrapper">
                            <table>
                                <thead>
                                    <tr>
                                    <th>Suite Number</th>
                                    <th> Title</th>
                                    <th>Schedule Date and Time</th>
                                    <th>Zoom Link</th>
                                    <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                { docs.map((item, id) => { return (
                                    <tr key={id}>
                                        {/* <td>{item.id}</td> */}
                                        <td>{getCaseNum(item.caseId)}</td>
                                        <td>{getTitle(item.caseId)}</td>
                                        <td className={ item.schedule!=null ?'date-time' : 'date-time pends'}>{item.schedule!=null ? moment(item.schedule).format("dddd, MMMM Do YYYY h:mm a") : 'No Scheduled Date'}</td>
                                        <td className={item.schedule!=null ? 'zoom' : 'zoom pends'}>{item.zoomLink ? <a href={item.zoomLink} target='_blank'> Zoom Link </a>: 'Meeting link yet to be created'}</td>
                                        <td className='view-doc'><button className='red' onClick={()=>onView(item)}>View Documents Attached</button></td>
                                    </tr>
                                )})}
                                  
                                   
                                </tbody>
                            </table>
                        </div>
                    </div>} 
                </div>
            }

            { 
                profile.role === 'e-DM' && <div className="document-manager">
                <div className="dashboard-view">
                    <h2>Transaction Report</h2>
                    <div className="chart-box">
                        <div className="graph">
                            The graph would show here
                            This is a placeholder space
                        </div>
                    </div>
                </div>
                <div className="dashboard-view">
                    <h2>Quick Actions - New Affidavit Template</h2>
                    <div className="template-acts">
                        <div className="new-card">
                            <Link to={`/templates/affidafits/create`}>
                                <FontAwesomeIcon icon={faPlus} />
                                <p>New Blank Template</p>
                            </Link>
                        </div>
                        <div className="action-cards">
                            <div className="act-card">
                                <Link to={`/templates/51/view`}>
                                    <FontAwesomeIcon icon={faUserPen} />
                                    <p>Change of Name</p>
                                </Link>
                            </div>
                            <div className="act-card">
                                <Link to='/templates/52/view'>
                                    <FontAwesomeIcon icon={faFileLines} />
                                    <p> Loss of Driver License</p>
                                </Link>
                            </div>
                            <div className="act-card">
                                <Link to='/templates/56/view'>
                                    <FontAwesomeIcon icon={faUserLock} />
                                    <p>Affidavit of Consent</p>
                                </Link>
                            </div>
                            <div className="act-card">
                                <Link to='/templates/78/view'>
                                    <FontAwesomeIcon icon={faFolderOpen} />
                                    <p>General Affidavit</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dashboard-view">
                    <h2>Quick Actions - New Document Template</h2>
                    <div className="template-acts">
                        <div className="new-card">
                            <Link to='/templates/document/create'>
                                <FontAwesomeIcon icon={faPlus} />
                                <p>New Blank Template</p>
                            </Link>
                        </div>
                        <div className="action-cards">
                            <div className="act-card">
                                <Link to='/templates/17/view'>
                                    <FontAwesomeIcon icon={faUserPen} />
                                    <p>Amended Statement of Claim </p>
                                </Link>
                            </div>
                            <div className="act-card">
                                <Link to='/templates/33/view'>
                                    <FontAwesomeIcon icon={faFileLines} />
                                    <p>Claimant's Statement On Oath</p>
                                </Link>
                            </div>
                            <div className="act-card">
                                <Link to='/templates/38/view'>
                                    <FontAwesomeIcon icon={faUserLock} />
                                    <p>FORM 18</p>
                                </Link>
                            </div>
                            <div className="act-card">
                                <Link to='/templates/40/view'>
                                    <FontAwesomeIcon icon={faFolderOpen} />
                                    <p>List of Authorities</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
               
                </div>
            }

            {
                (profile.role=='CommissionerForOaths' || profile.role=='e-CFO' || profile.role=='e-Commissioner for Oaths' || profile.role=='ACR' || profile.role=='e-ACR')  && <div className="cfo">
                    <div className="dashboard-view">
                        <h2>Quick Actions</h2>
                        <div className="action-btns" style={{flexWrap:'wrap'}}>
                            <div className="upload-dash" onClick={() => openUpload('initial')}>
                                {initial==''?<div className="icon-text" >
                                    <FontAwesomeIcon icon={faSignature} />
                                    <p>Upload Initial</p>
                                </div>:<img src={ initial} alt="Initial"  style={{width:100, height:100}}/>}
                                {initial!='' && <div className="icon-text" > <p> Initial</p> </div>}
                                <FontAwesomeIcon icon={faCircleInfo} />
                            </div>
                            <div className="upload-dash" onClick={() => openUpload('sign')}>
                                {sign==''?<div className="icon-text" >
                                    <FontAwesomeIcon icon={faSignature} />
                                    <p>Upload Signature</p>
                                </div>:<img src={ sign} alt="Signature"  style={{width:100, height:100}}/>}
                                {sign!='' && <div className="icon-text" > <p> Signature</p> </div>}
                                <FontAwesomeIcon icon={faCircleInfo} />
                            </div>
                            <div className="upload-dash" onClick={() => openUpload('seal')}>
                              {seal==''?<div className="icon-text">
                                    <FontAwesomeIcon icon={faEnvelopeCircleCheck} />
                                    <p>Upload Seal</p>
                                </div>:<img src={ seal} alt="Seal" style={{width:100, height:100}} />}
                                {seal!='' && <div className="icon-text" > <p>{isCfo && 'CFO'} Seal</p> </div>}
                                <FontAwesomeIcon icon={faCircleInfo} />
                            </div>

                            <div className="upload-dash" onClick={() => openUpload('stamp')}>
                                {stamp==''? <div className="icon-text"> 
                                    <FontAwesomeIcon icon={faStamp} />
                                    <p>Upload Stamp</p>
                                </div>:<img src={stamp} alt="Stamp"  style={{width:100, height:100}}/>}
                                {stamp!='' && <div className="icon-text" > <p>{isCfo && 'CFO'} Stamp</p> </div>}
                                <FontAwesomeIcon icon={faCircleCheck} className='uploaded-it'/>
                            </div>

                            <div className="upload-dash" onClick={() => openUpload('passport')}>
                                {passport==''?<div className="icon-text">
                                
                                    <FontAwesomeIcon icon={faAddressCard} />
                                    <p>Upload Passport</p>
                                </div>:<img src={passport} alt="Passport"  style={{width:100, height:100}} />}
                                {passport!='' && <div className="icon-text" > <p> Passport</p> </div>}
                                <FontAwesomeIcon icon={faCircleCheck} className='uploaded-it' />
                            </div>
                        </div>
                    </div>
                    <div className="table-apts">
                        <div className="top-table">
                            <div className="no-of-docs">
                                <p className={ whichTable === 'submitted' ? 'active' : ''} onClick={() => changeTable('submitted')}>Submitted Documents({docs.length})</p>
                               {/*  <p className={ whichTable === 'approved' ? 'active' : ''} onClick={() => changeTable('approved')}>Approved Documents(20)</p> */}
                            </div>
                        </div>
                        <div className="table-wrapper">
                            <table>
                                <thead>
                                    <tr>
                                    <th>Suite Number</th>
                                    <th> Title</th>
                                    <th>Schedule Date and Time</th>
                                    <th>Zoom Link</th>
                                    <th>Schedule</th>
                                    <th>View Document</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        whichTable === 'submitted' && docs.map((item, id) => { return(
                                            <tr key={id}>
                                                <td className='cfo-ref'><FontAwesomeIcon icon={faFileLines} /> {getCaseNum(item.caseId)}</td>

                                                <td>{getTitle(item.caseId)}</td>
                                                <td className={ item.schedule!=null ?'date-time' : 'date-time pends'}>{item.schedule!=null ? moment(item.schedule).format("dddd, MMMM Do YYYY h:mm a") : 'Pending'}</td>
                                                <td className={item.schedule!=null ? 'zoom' : 'zoom pends'}> {item.zoomLink ?  <a href={item.zoomLink} target='_blank'> Zoom Link </a>: 'Meeting link yet to be created'}  </td>

                                                <td ><button className='red' onClick={()=> onSelectSchedule(item)}> {item.schedule!=null ? 'Reschedule' : 'Schedule'} </button></td>
                                                <td ><button className='black' onClick={() => onView(item) }>View  </button></td>
                                            
                                            </tr>
                                        )})
                                    }
                                    {
                                        whichTable === 'approved' &&  approvedDocs.map((item, id) => { return(
                                            <tr key={id}>
                                                <td className='cfo-ref'><FontAwesomeIcon icon={faFileLines} /> {item.ref}</td>
                                                <td>{item.title}</td>
                                                <td>{item.datecreated}</td>
                                                <td className='cfo-stat approved'>{item.status}</td>
                                            </tr>
                                        )})
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            }
            <div className="footer-tech">
                <p>Powered By First Hightower InfoTech</p>
                <p>© 2024</p>
            </div>
        </div>
       {openLegalDoc && <div className={  "template-pop open" }>
            <div className="templates-wrap">
                <div className="heading">
                    <h2>{ typeTemp === 'case-doc'  ? 'Case Documents' : 'Affidavit Templates'}</h2>
                    <div className="icon" onClick={() => setOpenLegalDoc(false)}>
                        <FontAwesomeIcon icon={faClose} />
                    </div>
                </div>
                <div className="temp-body">
                    {
                          templates.map((item, id) => { return (
                           <div className='lnk'  key={id} >
                            <div className="temp-card" onClick={() =>onSelectTemplate(item)} title={item.note}>
                                    <div className="temp-type">
                                        <h3>{item.title}</h3>
                                        <p>Tap here to create affidavit</p>
                                    </div>
                                    <FontAwesomeIcon icon={faFileCirclePlus} />
                                </div>
                           </div>
                                
                            
                        )}) 
                    }
                </div>
                
            </div>
        </div>} 

        <div className={ isUploadClick ? "template-pop open" : "template-pop"}>
            <div className="upload-wrap">
                <h3>Upload {uploadType}</h3>
                <div className="upload-file-btn">
                    <label htmlFor="upload-input">{ selectedImage ? 'Change Image' : 'Upload Image'}</label>
                    <input
                        type="file"
                        id="upload-input"
                        accept="image/*"
                        onChange={handleImageChange}
                    />
                     {selectedImage && (
                        <img src={selectedImage} alt="Uploaded Document" style={{width:150}} />
                        )}
                </div>  

                <p className="warn">Maximum File Upload: 2MB</p>

             

                <button className='red' onClick={() => cancelUpload()}>Cancel</button>
                <button className="black" onClick={onSaveInst}>Upload</button>
            </div>
        </div>
      {isSchedule && <div className={ "template-pop open" }>
            <div className="upload-wrap">
                <h3>Schedule appointment </h3>
                
                <p className="warn">Zoom Link</p>

                <input type="text" placeholder='Zoom Link' value={schedule.zoom} onChange={(e)=>setSchedule({...schedule, zoom:e.target.value})} />
                <p className="warn">Set The Date</p>

                <input type="date" placeholder='Zoom meeting date' value={schedule.date} onChange={(e)=>setSchedule({...schedule, date:e.target.value})} />
                <p className="warn">Set The Time</p>

                <input type="time" placeholder='Zoom meeting time' value={schedule.time} onChange={(e)=>setSchedule({...schedule, time:e.target.value})} />

              
                <button className="black" onClick={onSaveSchedule}>Save Schedule</button>
                  <button className='red' onClick={() => setIsSchedule(false)}>Cancel</button>
            </div>
        </div>}  
        <BackLoader open={isLoading}  />
        {alert.open && <JisAlert {...alert}/>}  
        {isPay && <div className={ "success open" }>
                <div className="success-box">
                    <h2>{Constants.formatCurrency(config.affidavitAmount) }</h2>
                    <p>Payment for Affidavit  </p>
                    <form className='form-inp' action='/paystack.html'>
                        <input type='hidden' name="name" value={profile.firstName}  />
                        <input type='hidden' name="email" value={profile.email}   />
                        <input type='hidden' name="phone" value={profile.phone}   />
                        <input type='hidden' name="returnurl" value={`${Constants.baseurl}/templates/AffidavitDocuments/`}   />
                        <input type='hidden' name="amount" value={config.affidavitAmount} />
                        <input type='hidden' name="docref" value={`${selectedtempid}-0-${profile.userid}-${profile.username}`} />
                      <button className='red' type='submit'>Pay Now</button>  <button className='red' onClick={onCancel} type='button'>Cancel</button> 
                    </form>  
                </div>
            </div>} 
    </div>
  )
}

export default DMDashboard